export default {
  getStatusWithIndex(index, statusList) {
    let status = null;
    let cnt = 0;
    for (let key in statusList) {
      if (cnt == index) {
        status = key;
      }
      cnt++;
    }
    return status;
  }
};
